import { LinkProps } from '@tanstack/react-router';

import { PlatformName, usePlatform } from '@/features/users';

const platformTraffickingLandingRoutes: Record<PlatformName, LinkProps['to']> =
  {
    'The Trade Desk': '/trafficking/campaign',
    Meta: '/trafficking/campaign',
    DV360: '/trafficking/insertion-order',
    TikTok: '/trafficking/campaign',
  };

const usePlatformTraffickingLandingRoute = () => {
  const platform = usePlatform();
  const landingRoute: LinkProps['to'] =
    platformTraffickingLandingRoutes[platform];

  return landingRoute;
};

export default usePlatformTraffickingLandingRoute;
